import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3229">
      <Navbar data-id="element-3230" />
      <main data-id="element-3231">
        <ConsularAffairs data-id="element-3232" />
      </main>
      <Footer data-id="element-3233" />
      <FeedbackPopup data-id="element-3234" />
    </div>;
}